import { Component } from '@angular/core'

@Component({
  templateUrl: './eu-kuluttajamyynti.dialog.html',
  styleUrls: ['./eu-kuluttajamyynti.dialog.css'],
  standalone: false,
})
export class EuKuluttajamyyntiDialog {}
